import { isOneOf } from "./isOneOf";

const msalConsumerNeedNlpRedirectErrors = ["NeedsRedirectWithNlp"];

export function isMsalNeedNlpRedirectError(message: string | undefined): boolean {
    return isOneOf(msalConsumerNeedNlpRedirectErrors, message);
}
